import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        options: {
            width: 325,
        },
    }
})

export default useStyles
